<template>
  <div class="menuList">
    <van-collapse
      v-model="menuIndex.active1"
      accordion
      :border="false"
      @change="menuClick($event, 'active1')"
    >
      <van-collapse-item v-for="(item1, index1) in menuData" :name="index1" :key="index1">
        <template #title>
          <div class="menu-icon" v-if="item1.Icon">
            <van-image width="20" height="20" :src="getMenuIcon(item1.Icon)"></van-image>
          </div>
          <div class="menu-name">{{ item1.MenuName }}</div>
        </template>
        <template #value>
          <div class="menu-badge" v-if="item1.MessageCount">
            {{ item1.MessageCount }}
          </div>
        </template>
        <div
          :class="['menu-wrapper1', item2.ChildList.length > 0 ? 'no-border' : '']"
          v-for="(item2, index2) in item1.ChildList"
          :key="index2"
        >
          <div
            class="menu-click"
            v-if="item2.ChildList && item2.ChildList.length == 0"
            @click="gotoPage(item2.MenuUrl)"
          >
            <div class="menu-click-item2">{{ item2.MenuName }}</div>
            <div class="menu-click-right">
              <div class="menu-badge" v-if="item2.MessageCount">
                {{ item2.MessageCount }}
              </div>
            </div>
          </div>
          <div v-else>
            <van-collapse
              v-model="menuIndex.active2"
              accordion
              :border="false"
              @change="menuClick($event, 'active2')"
            >
              <van-collapse-item :title="item2.MenuName" :name="index2" :key="index2">
                <template #value>
                  <div class="menu-badge" v-if="item2.MessageCount">
                    {{ item2.MessageCount }}
                  </div>
                </template>
                <div
                  class="menu-wrapper2"
                  v-for="(item3, index3) in item2.ChildList"
                  :key="index3"
                >
                  <div class="menu-click" @click="gotoPage(item3.MenuUrl)">
                    <div class="menu-click-item3">{{ item3.MenuName }}</div>
                    <div class="menu-click-right">
                      <div class="menu-badge" v-if="item3.MessageCount">
                        {{ item3.MessageCount }}
                      </div>
                    </div>
                  </div>
                </div>
              </van-collapse-item>
            </van-collapse>
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>
<script>
import Vue from "vue";
import { Icon, Image, Collapse, CollapseItem } from "vant";
Vue.use(Icon).use(Image).use(Collapse).use(CollapseItem);

export default {
  name: "MenuList",
  components: {},
  props: {
    menuData: {
      type: Array,
      default: null,
    },
    menuIndex: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      icons: [
        //内部员工
        "el-icon-user",
        "el-icon-truck",
        "el-icon-s-order",
        "el-icon-shopping-cart-1",
        "el-icon-receiving",
        "el-icon-notebook-2",
        "el-icon-house",
        "el-icon-data-line",
        "el-icon-s-marketing",
        "el-icon-s-custom",
        "el-icon-s-cooperation",
        "el-icon-folder-opened",
        "el-icon-set-up",
        //企业客户
        "el-icon-direction",
        "el-icon-search",
        "el-icon-money",
      ],
    };
  },
  updated() {
    this.setBorderStyle();
  },
  methods: {
    setBorderStyle() {
      var elements = document.querySelectorAll(".no-border");
      if (elements && elements.length > 0) {
        elements.forEach((element) => {
          element.parentElement.style.border = "none";
        });
      }
    },
    getMenuIcon(Icon) {
      var iconName = this.icons.find((icon) => icon == Icon);
      if (iconName) {
        return require("@/assets/img/menu/" + iconName + ".png");
      } else {
        return require("@/assets/img/menu/el-icon-new.png");
      }
    },
    menuClick(id, level) {
      var data = this.menuIndex;
      if (level == "active1") {
        data.active1 = id;
      }
      if (level == "active2") {
        data.active2 = id;
      }
      localStorage.setItem("MenuList", JSON.stringify(data));
      this.setBorderStyle();
    },
    gotoPage(path) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: path,
        query: [],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";

.menuList {
  min-height: 120vh;

  ::v-deep .van-collapse {
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }

    .van-cell::after {
      border: none !important;
    }

    .van-collapse-item--border::after {
      border: none !important;
    }
  }

  ::v-deep .van-collapse-item__title--expanded + .van-collapse-item__wrapper {
    .van-collapse-item__content:has(.no-border) {
      border: none !important;
    }

    .van-collapse-item__content {
      border-bottom: 1px solid #ebedf0;
    }
  }

  ::v-deep .van-collapse-item__content {
    padding: 0px 16px;
    background: transparent;
  }

  ::v-deep .van-cell__title {
    flex: 10;
    font-size: 16px;
    line-height: 30px;
  }

  ::v-deep .van-cell__value {
    vertical-align: middle;
    height: 30px;
    line-height: 2;
  }

  ::v-deep .van-icon {
    font-size: 20px;
    height: 30px;
    line-height: 30px;
  }

  .menu-badge {
    background-color: #ff4949;
    color: #fff;
    display: inline-block;
    text-align: center;
    white-space: nowrap;
    border-radius: 10px;
    font-size: 10px;
    font-weight: bold;
    height: 18px;
    width: 18px;
    line-height: 18px;
  }

  .menu-icon {
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;

    .van-image {
      display: block;
    }
  }

  .menu-name {
    display: inline-block;
    vertical-align: middle;
  }

  .menu-wrapper1 {
    .menu-click {
      line-height: 44px;

      .menu-click-item2,
      .menu-click-item3 {
        vertical-align: middle;
        display: inline-block;
        width: 91%;
      }

      .menu-click-right {
        vertical-align: middle;
        display: inline-block;
        text-align: center;
        width: 9%;
      }
    }
  }

  .menu-wrapper2 {
    .menu-click {
      line-height: 44px;

      .menu-click-item2,
      .menu-click-item3 {
        vertical-align: middle;
        display: inline-block;
        width: 91%;
      }

      .menu-click-right {
        vertical-align: middle;
        display: inline-block;
        text-align: center;
        width: 9%;
      }
    }
  }
}
</style>
